module.exports = __webpack_public_path__ + "static/portfolio3b-1164f70053573a9fb0e7fea526654e50.jpg";